import React from 'react'
import { isSentryEnabled, Sentry } from './libs/sentry'
import App from './app'

const ErrorFallback = ({ error, resetError }) => (
  <div style={{ padding: 20, textAlign: 'center', fontFamily: 'sans-serif' }}>
    <h1 style={{ color: '#ff4d4f' }}>Something went wrong</h1>
    <p>An unexpected error occurred. Our team has been notified.</p>
    <details style={{ marginTop: 20, textAlign: 'left', maxWidth: 800, margin: '20px auto' }}>
      <summary style={{ cursor: 'pointer', marginBottom: 10 }}>Error details</summary>
      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{error?.message}</pre>
    </details>
    <button type="button" onClick={resetError} style={{ marginTop: 20, padding: '8px 16px' }}>
      Try again
    </button>
  </div>
)

export default function Root() {
  if (isSentryEnabled()) {
    return (
      <Sentry.ErrorBoundary fallback={ErrorFallback}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </Sentry.ErrorBoundary>
    )
  }
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
